module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAkCAYAAAC9itu8AAAAAXNSR0IArs4c6QAAAF9JREFUOE9jZCARMJKonmFUAzEhNhpKgySUpKSkShgYGIqIcQ4DA0MfOOKI1NT37NmzHnhME9AEVgwyHCVp4NAEV4yhAYvzUBRj1YCkiQHmDOQAGU2txCSP0VAaHKEEAIPIGee+Y68QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-icon-down.png
// module id = 218
// module chunks = 1 5